import mergeWith from 'lodash.mergewith';
var overrideEverything = function (_, source) { return source; };
export var mergeDeep = function (target, source) { return mergeWith(target, source, overrideEverything); };
var overrideUndefinedOnly = function (object, source) { return object !== null && object !== void 0 ? object : source; };
export var mergeDeepUndefined = function (target, source) { return mergeWith(target, source, overrideUndefinedOnly); };
